/**
 * Directive: detailList
 */
angular.module('acme.common.directive.detailList', [
  'acme.common.service.helpers',
  'acme.common.service.permissions',
  'acme.common.directive.detailListTemplate'
])
.directive('detailList', [function () {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/detailList/detailList.tpl.html',
      scope: {
        options: '=',
        items: '='
      },

      link: function ($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: [
        '$scope',
        '$filter',
        '$compile',
        '$templateRequest',
        'HelpersService',
        'PermissionsService',
        function DetailListController(
          $scope,
          $filter,
          $compile,
          $templateRequest,
          HelpersService,
          PermissionsService
        ) {
        var ctrl = {
          rawItems: [],
          items: [],
          exclude: [],
          include: [],
          filters: {},
          templates: {},
          mappings: {},
          clickHandler: {},
          columns: 0,
          layout: 'N',
          sorting: false,
          showEmpty: false,
          columnWidth: 12,

          init: function () {
            ctrl.setOptions($scope.options);

            if (typeof $scope.options.data === 'string') {
              $scope.$on('$destroy', $scope.$parent.$watchCollection($scope.options.data, function (newValue) {
                ctrl.rawItems = newValue;
                ctrl.items = ctrl.processItems(newValue);
              }));
            } else if ($scope.items) {
              $scope.$on('$destroy', $scope.$watchCollection('items', function (newValue) {
                ctrl.rawItems = newValue;
                ctrl.items = ctrl.processItems(newValue);
              }));
            }

            $scope.$on('$destroy', $scope.$watch('options', function (newValue, oldValue) {
              ctrl.setOptions(newValue);
              ctrl.items = ctrl.processItems(ctrl.rawItems);
            }));
          },

          setOptions: function (options) {
            ctrl.columns = options.columns || 0;
            ctrl.exclude = options.exclude || [];
            ctrl.include = options.include || [];
            ctrl.filters = options.filters || {};
            ctrl.templates = options.templates || {};
            ctrl.mappings = options.mappings || {};
            ctrl.clickHandler = options.clickHandler || {};
            ctrl.layout = options.layout || 'N';
            ctrl.sorting = options.sorting;
            ctrl.showEmpty = options.showEmpty;
            ctrl.columnWidth = options.columnWidth ? options.columnWidth : Math.floor(12 / ctrl.columns);
            ctrl.hideLabels = options.hideLabels || false;
            ctrl.hideTitles = options.hideTitles || [];
          },

          hideTitle: function (name) {
            return ctrl.hideTitles.find(function (value) {
              return value === name
            })
          },

          hasTemplate: function (name) {
            return ctrl.templates.hasOwnProperty(name) && ctrl.checkTemplatePermissions(name);
          },

          checkTemplatePermissions: function (name) {
            var r = true;
            if (ctrl.templates[name].permissions) {
              r = PermissionsService.check(ctrl.templates[name].permissions);
            }
            return r;
          },

          applyFilters: function (field, value, items) {
            var r = value;

            if (ctrl.filters.hasOwnProperty(field) && typeof ctrl.filters[field] === 'function') {
              r = ctrl.filters[field](value, items);
            }

            return r;
          },

          processItems: function (items) {
            var i, ii,
                entry,
                index = 0,
                totalLen = 0,
                splitLen = 0,
                orderIndex = 0,
                value = '',
                cols = [],
                r = [];

            items = items || {};

            /**
             * Explicitly sets properties that must be included in our items object so they go through our for-in loop
             */
            if (ctrl.showEmpty) {
              ctrl.include.forEach(function (item) {
                items[item] = items[item] || undefined;
              });
            }

            for (i in items) {
              if (items.hasOwnProperty(i)) {
                value = ctrl.applyFilters(i, items[i], items);
                entry = {
                  label: (ctrl.mappings.hasOwnProperty(i)) ? ctrl.mappings[i] : HelpersService.camelCaseSplit(i).join(' '),
                  value: value,
                  name: i
                };

                if (ctrl.include.length > 0) {
                  orderIndex = ctrl.include.indexOf(i);

                  if (orderIndex >= 0 && (value || ctrl.showEmpty)) {
                    if (ctrl.hasTemplate(i)) {
                      entry.template = ctrl.templates[i];
                    }
                    entry.orderIndex = orderIndex;
                    r.splice(orderIndex, 0, entry);
                  }
                } else {
                  if (ctrl.exclude.indexOf(i) === -1 && value) {
                    entry.orderIndex = i;
                    r.push(entry);
                  }
                }
              }
            }

            totalLen = r.length;

            if (ctrl.sorting) {
              r.sort(function (a, b) {
                var r = 0;

                if (a.label > b.label) {
                  r = 1;
                } else if (a.label < b.label) {
                  r = -1;
                }

                return r;
              });
            }else if (ctrl.include.length > 0) {
              //display in order of include list
              r.sort(function (a, b) {
                var r = 0;

                a.orderIndex = a.orderIndex >= 0 ? a.orderIndex : totalLen;
                b.orderIndex = b.orderIndex >= 0 ? b.orderIndex : totalLen;

                if (a.orderIndex > b.orderIndex) {
                  r = 1;
                } else if (a.orderIndex < b.orderIndex) {
                  r = -1;
                }

                return r;
              });
            }


            if (ctrl.layout === 'N') {

              splitLen = parseInt(Math.ceil(totalLen / ctrl.columns), 10);

              for (i=0;i<ctrl.columns;i++) {
                cols[i] = r.slice(i * splitLen, (i * splitLen) + splitLen);
              }

            }else{

              for (i=0,ii=totalLen;i<ii;i++) {
                index = i % ctrl.columns;

                if (!cols[index]) {
                  cols[index] = [];
                }

                cols[index].push({
                  label: r[i].label,
                  name: r[i].name,
                  value: r[i].value,
                  orderIndex: r[i].orderIndex
                });

              }

            }

            r = cols;

            return r;
          }
        };

        $scope.detailList = ctrl;
        ctrl.init();

      }]

    };

}]);